exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3DuaW{position:relative;height:100vh;padding-top:20px}._3DuaW:focus{outline:none}._3L3oT{position:relative;height:100vh;padding-top:0;background-color:#f2f2f2;text-align:center}body.reader-night-mode ._3L3oT{background-color:#3d3d3d}._3L3oT:after{content:\"\";height:100%}._3L3oT:after,._3L3oT span{display:inline-block;vertical-align:middle}._3L3oT span{font-size:64px;color:#e6e6e6;text-shadow:0 1px 0 #fff}body.reader-night-mode ._3L3oT span{color:#595959;text-shadow:0 1px 0 #666}._3DuaW ._3-3KB{position:absolute;right:5px;top:2px}body.reader-night-mode ._3DuaW ._3-3KB{color:#b3b3b3}.gGAch{background-color:#d9d9d9}body.reader-night-mode .gGAch{background-color:#2e2e2e}", ""]);

// exports
exports.locals = {
	"editor-wrapper": "_3DuaW",
	"editor-wrapper-no-notes": "_3L3oT",
	"saving-status": "_3-3KB",
	"writing-mode": "gGAch"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/components/EditorWrapper/EditorWrapper.scss
// module id = 6rxM
// module chunks = 0